import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { Box } from '@mui/material';

import { Typography, LoadingOverlay } from '@occc/ui-design-system';
import { FormLayout } from '@occc-app/routes/CampaignComponents/components/FormLayout';
import { ScheduleDates } from '@occc-app/routes/CampaignComponents/components/ScheduleDates';
import { CanEditFormFields } from '@occc-app/App/CanEditFormFieldsContext';

import { GeneralSurveyScheduleFormProps, GeneralSurveyScheduleFormValues } from './types';
import { validateSurveyScheduleForm } from './validation';

import { FooterActions } from '../FooterActions';
import { SurveyTabs } from '../../constants';

export const ScheduleForm: React.FC<GeneralSurveyScheduleFormProps> = ({
  initialValues,
  onSubmit,
  onNextStepClick,
  onCancelClick,
  loading,
  isEntityExists,
  isUserPermittedToEditSurvey,
}) => {
  const renderForm: FormRenderProps<GeneralSurveyScheduleFormValues>['render'] = React.useCallback(
    ({ handleSubmit, submitting, values, dirty }: FormRenderProps<any>) => {
      const handleCancelClick = () => {
        onCancelClick(dirty);
      };

      const actions = (
        <FooterActions
          onNextStepClick={onNextStepClick}
          onCancel={handleCancelClick}
          isSubmitDisabled={submitting}
          isEntityExists={isEntityExists}
          currentTab={SurveyTabs.Schedule}
          isUserPermittedToEditSurvey={isUserPermittedToEditSurvey}
        />
      );

      return (
        <form onSubmit={handleSubmit} data-testid='schedule-form'>
          <FormLayout actions={actions}>
            <Box p={3}>
              <Typography variant='h6' paragraph>
                Schedule Survey
              </Typography>
              <CanEditFormFields isEditable={isUserPermittedToEditSurvey}>
                <ScheduleDates values={values} />
              </CanEditFormFields>
            </Box>
          </FormLayout>
        </form>
      );
    },
    [isEntityExists, isUserPermittedToEditSurvey, onCancelClick, onNextStepClick],
  );

  return (
    <Box position='relative'>
      <CanEditFormFields isEditable={isUserPermittedToEditSurvey}>
        <Form<GeneralSurveyScheduleFormValues>
          initialValues={initialValues}
          onSubmit={onSubmit}
          render={renderForm}
          validate={validateSurveyScheduleForm}
        />
      </CanEditFormFields>
      {loading && <LoadingOverlay rounded />}
    </Box>
  );
};
